import { Injectable } from "@angular/core";
import { Adapter } from "src/app/adapter";
import * as moment from "moment";

export class CompanyMaster {
  constructor(
    public id: number,
    public name: string,
    public nbrPeriods: number,
    public yearStartDate: Date,
    public apYearStartDate: Date,
    public arYearStartDate: Date,
    public currPeriod: number,
    public apCurrPeriod: number,
    public arCurrPeriod: number,
    public prd1EndDate: Date,
    public prd2EndDate: Date,
    public prd3EndDate: Date,
    public prd4EndDate: Date,
    public prd5EndDate: Date,
    public prd6EndDate: Date,
    public prd7EndDate: Date,
    public prd8EndDate: Date,
    public prd9EndDate: Date,
    public prd10EndDate: Date,
    public prd11EndDate: Date,
    public prd12EndDate: Date,
    public prd13EndDate: Date,
    public changeID: string,
    public lastUpdated: moment.Moment
  ) {}
}

@Injectable({
  providedIn: "root"
})
export class CompanyMasterAdapter implements Adapter<CompanyMaster> {
  adapt(item: any): CompanyMaster {
    return new CompanyMaster(
      item.COROWID,
      item.CONAME,
      item.CONBRPERIODS,
      item.COYEARSTARTDATE,
      item.COAPYEARSTARTDATE,
      item.COARYEARSTARTDATE,
      item.COCURRPERIOD,
      item.COAPCURRPERIOD,
      item.COARCURRPERIOD,
      item.COPRD1ENDDATE,
      item.COPRD2ENDDATE,
      item.COPRD3ENDDATE,
      item.COPRD4ENDDATE,
      item.COPRD5ENDDATE,
      item.COPRD6ENDDATE,
      item.COPRD7ENDDATE,
      item.COPRD8ENDDATE,
      item.COPRD9ENDDATE,
      item.COPRD10ENDDATE,
      item.COPRD11ENDDATE,
      item.COPRD12ENDDATE,
      item.COPRD13ENDDATE,
      item.COCHANGEID,
      item.COLASTUPDATED
    );
  }
}
